import { render, staticRenderFns } from "./datosPersonales.vue?vue&type=template&id=4dad37b0"
import script from "./datosPersonales.vue?vue&type=script&lang=js"
export * from "./datosPersonales.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports